import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"notes"}/>
}
